import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  id: "image-modal",
  class: "modal modal-open"
}
const _hoisted_2 = { class: "flex justify-between pb-2" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = {
  key: 0,
  class: "text-lg font-bold"
}
const _hoisted_5 = { class: "-mr-2 -mt-2 ml-4 flex" }
const _hoisted_6 = ["src"]

import {
  XMarkIcon,
} from '@heroicons/vue/24/outline';
import {
  PhDownload,
} from '@phosphor-icons/vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageModal',
  props: {
  imageUrl: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    default: '',
  },
  boxClass: {
    type: String,
    default: 'max-w-screen-lg',
  },
  imgClass: {
    type: String,
    default: '',
  },
  isDownloadable: {
    type: Boolean,
    default: true,
  },
},
  emits: ["close", "download"],
  setup(__props) {







return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["modal-box relative", __props.boxClass])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (__props.title)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_4, _toDisplayString(__props.title), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-circle border-0 font-bold",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          }, [
            _createVNode(_unref(XMarkIcon), { class: "size-6 text-violet-600" })
          ])
        ])
      ]),
      _createElementVNode("img", {
        src: __props.imageUrl,
        class: _normalizeClass(["min-h-40", __props.imgClass]),
        alt: "modal-image"
      }, null, 10, _hoisted_6),
      (__props.isDownloadable)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn ml-auto mt-6 flex flex-nowrap bg-[#EEEEEE] shadow-md",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('download')))
          }, [
            _createElementVNode("span", null, [
              _createVNode(_unref(PhDownload), { class: "size-5 stroke-2" })
            ]),
            _createTextVNode(" ডাউনলোড করো ")
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})